import { useState, useEffect } from "react"

const DEFAULT_PAGE_SIZE = 10

export type PaginationHook = {
  pageIndex: number
  pageSize: number
  pageCount: number
  prevDisabled: boolean
  nextDisabled: boolean
  onNextPage: () => void
  onPrevPage: () => void
  changePageSize: (newPageSize: number) => void
}

export const usePagination = (dataCount: number, paginationHandler?: (pageIndex: number, pageSize: number) => void) => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [pageIndex, setPageIndex] = useState(0)
  const [pageCount, setPageCount] = useState(1)
  const [prevDisabled, setPrevDisabled] = useState(true)
  const [nextDisabled, setNextDisabled] = useState(true)
  useEffect(() => {
    setPageSize(DEFAULT_PAGE_SIZE)
    setPageIndex(0)
    const newPageCount = dataCount ? Math.ceil(dataCount / DEFAULT_PAGE_SIZE) : 1
    setPageCount(newPageCount)
    setPrevDisabled(true)
    setNextDisabled(newPageCount === 1)
  }, [dataCount])

  const changePage = (newPageIndex: number) => {
    setPageIndex(newPageIndex)
    setPrevDisabled(newPageIndex === 0)
    setNextDisabled(newPageIndex === pageCount - 1)
    if (paginationHandler) {
      paginationHandler(newPageIndex, pageSize)
    }
  }

  const onNextPage = () => {
    changePage(pageIndex + 1)
  }

  const onPrevPage = () => {
    changePage(pageIndex - 1)
  }

  const changePageSize = (newPageSize: number) => {
    const newPageCount = dataCount ? Math.ceil(dataCount / newPageSize) : pageCount
    const newPageIndex = pageIndex >= newPageCount - 1 ? newPageCount - 1 : pageIndex
    setPageCount(newPageCount)
    setPageIndex(newPageIndex)
    setPageSize(newPageSize)
    setPrevDisabled(newPageIndex === 0)
    setNextDisabled(newPageIndex === newPageCount - 1)
    if (paginationHandler) {
      paginationHandler(newPageIndex, newPageSize)
    }
  }

  return {
    pageIndex,
    pageSize,
    pageCount,
    prevDisabled,
    nextDisabled,
    onNextPage,
    onPrevPage,
    changePageSize,
  }
}
